module.exports = __webpack_public_path__ + "img/t4-petition.f322c522.png";